<template>
    <div class="admin">
        <b-container>
            <b-row v-if="isActivity">
                <b-col cols="6" class="text-primary">
                    <router-link :to="{ name: 'termine'}" class="admin__button border-white border-right border-bottom bg-info d-flex align-items-center flex-column justify-content-center">
                        <font-awesome-icon fixed-width :icon="['far', 'calendar-alt']" /> Termine
                    </router-link>
                </b-col>
                <b-col cols="6" class="text-primary">
                    <router-link :to="{ name: 'event-edit', params: { Id: false }}" class="admin__button border-white border-bottom bg-info d-flex align-items-center flex-column justify-content-center"><font-awesome-icon fixed-width :icon="['far', 'calendar-plus']" /> Termine anlegen</router-link>
                </b-col>
            </b-row>
            <b-row v-if="isMemberAdmin">
                <b-col cols="6" class="text-primary">
                    <router-link :to="{ name: 'users'}" class="admin__button border-white border-right border-bottom bg-info d-flex align-items-center flex-column justify-content-center"><font-awesome-icon fixed-width :icon="['far', 'user-friends']" /> Mitglieder</router-link>
                </b-col>
                <b-col cols="6" class="text-primary">
                    <router-link :to="{ name: 'user-edit', params: { Id: false }}"  class="admin__button border-white border-bottom bg-info d-flex align-items-center flex-column justify-content-center"><font-awesome-icon fixed-width :icon="['far', 'user-edit']" /> Mitglieder anlegen</router-link>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: 'admin',
    computed: {
        ...mapGetters('auth', ['loggedIn', 'isActivity', 'isMemberAdmin']),
    }
}
</script>

<style lang="scss">
@import '../scss/variables';
    .admin {

        .col-6 {
            padding: 0;
        }

        &__button {
            padding: 30px 0;
            font-weight: $font-weight-bold;

            .fa-fw {
                height: 2.938em;
                width: auto
            }
        }
    }
</style>